import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DataGridColumnDefinition } from 'components';
import { AppConfigArea, AppConfigKey, FilterDefinitionType } from 'enums';
import { useUserContext, useUserContextUtils } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { AppConfig, AppConfigFilters, FilterDefinition } from 'types';
import { appConfigUtils, formUtils } from 'utils';

import { ConfigsPageTab } from '../ConfigsPageTab';

export const PayinRequisitesTab: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features.configs',
  });
  const { banks } = useUserContext();
  const { getBankName } = useUserContextUtils();

  const additionalColumns = useMemo(
    (): DataGridColumnDefinition<AppConfig>[] => [
      {
        header: t('fields.bank'),
        valueKey: 'bankId',
        valueFormatter: (bankId: string) => getBankName({ id: bankId }),
      },
    ],
    [t, getBankName],
  );

  const bankOptions = useMemo(() => formUtils.getOptions(banks), [banks]);

  const additionalFilters: FilterDefinition<AppConfigFilters>[] = useMemo(
    () => [
      {
        label: t('fields.key'),
        name: 'key',
        type: FilterDefinitionType.Enum,
        enum: [
          AppConfigKey.PaymentLinkDomains,
          AppConfigKey.PaymentLinkReplacements,
          AppConfigKey.RequisitesVerification,
        ],
        getDisplayName: appConfigUtils.getKeyLabel,
      },
      {
        label: t('fields.bank'),
        name: 'bankId',
        type: FilterDefinitionType.Select,
        options: bankOptions,
        getDisplayName: (bankId: string) => getBankName({ id: bankId }),
      },
    ],
    [bankOptions, t, getBankName],
  );

  return (
    <ConfigsPageTab
      area={AppConfigArea.PayinRequisites}
      additionalColumns={additionalColumns}
      additionalFilters={additionalFilters}
    />
  );
};
